import { useSelector } from "react-redux";

const useStoreUIAlertsSelector = () => {
  const selectStoreAlerts = (state: any) => state.alerts;

  return useSelector(selectStoreAlerts);
};

export default useStoreUIAlertsSelector;
